import type { UseLastSearchesList } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useTranslations } from 'next-intl'

import { useA11y } from '@maestro/core/a11y/a11y.context'

export const useLastSearchesList = ({
  removeSearch,
  setRemovalMessage,
}: UseLastSearchesList) => {
  const { announce } = useA11y()
  const t = useTranslations('commerce-blocks')

  const handleRemoveSearch = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    index: number,
    search: string,
    totalCount: number
  ) => {
    e.preventDefault()
    const message = t('search.search-deleted', { search })

    const searchInput = document.querySelector(
      'input[type="search"]'
    ) as HTMLElement
    if (searchInput) {
      searchInput.focus()
    }

    removeSearch(index)
    setRemovalMessage(message)

    setTimeout(() => {
      let focusTarget: HTMLElement | null = null

      if (index > 0) {
        focusTarget = document.querySelector(
          `[data-search-delete-index="${index - 1}"]`
        )
      } else if (totalCount > 1) {
        focusTarget = document.querySelector(`[data-search-delete-index="0"]`)
      } else {
        focusTarget = searchInput
      }

      if (focusTarget) {
        focusTarget.focus()
      }
    }, 200)
    announce(message, 'assertive')
  }

  return { handleRemoveSearch }
}
